import axios from 'axios'

export default {
  namespaced: true,
  state: {
    templates: [],
    currentTemplate: null,
    tokens: [],
    loading: false,
    saving: false,
    deleting: false,
    error: null,
    filterScope: 'all',
    filterSubjectType: 'all',
    filterActionType: 'all',
    filterMediaType: 'all'
  },
  mutations: {
    SET_TEMPLATES (state, templates) { state.templates = templates },
    SET_CURRENT_TEMPLATE (state, template) { state.currentTemplate = template },
    SET_TOKENS (state, tokens) { state.tokens = tokens },
    SET_LOADING (state, val) { state.loading = val },
    SET_SAVING (state, val) { state.saving = val },
    SET_DELETING (state, val) { state.deleting = val },
    SET_ERROR (state, err) { state.error = err },
    REMOVE_TEMPLATE (state, id) {
      state.templates = state.templates.filter(t => t.id !== id)
    },
    SET_FILTER (state, { key, value }) { state[key] = value }
  },
  getters: {},
  actions: {
    async fetchTemplates ({ commit, rootState }, params) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const companyId = (params && params.companyId) || (rootState.userCurrentCompany && rootState.userCurrentCompany.companyId)
        const globalOnly = (params && params.globalOnly) || false
        const result = await axios.get(`/api/company/${companyId}/notification-templates`, { params: { globalOnly } })
        commit('SET_TEMPLATES', result.data.templates || [])
        return result.data.templates || []
      } catch (e) {
        commit('SET_ERROR', e.response ? `${e.response.status}: ${e.response.statusText}` : e.message)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchTemplate ({ commit, rootState }, id) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const companyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
        const result = await axios.get(`/api/company/${companyId}/notification-templates/${id}`)
        commit('SET_CURRENT_TEMPLATE', result.data.template)
        return result.data.template
      } catch (e) {
        commit('SET_ERROR', e.response ? `${e.response.status}: ${e.response.statusText}` : e.message)
        return null
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async saveTemplate ({ commit, rootState }, payload) {
      commit('SET_SAVING', true)
      commit('SET_ERROR', null)
      try {
        const companyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
        const result = await axios.post(`/api/company/${companyId}/notification-templates`, payload)
        return result.data
      } catch (e) {
        commit('SET_ERROR', e.response ? `${e.response.status}: ${e.response.statusText}` : e.message)
        throw e
      } finally {
        commit('SET_SAVING', false)
      }
    },

    async deleteTemplate ({ commit, rootState }, id) {
      commit('SET_DELETING', true)
      commit('SET_ERROR', null)
      try {
        const companyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
        await axios.delete(`/api/company/${companyId}/notification-templates/${id}`)
        commit('REMOVE_TEMPLATE', id)
      } catch (e) {
        commit('SET_ERROR', e.response ? `${e.response.status}: ${e.response.statusText}` : e.message)
        throw e
      } finally {
        commit('SET_DELETING', false)
      }
    },

    async fetchTokens ({ commit, rootState }, { subjectType, actionType }) {
      commit('SET_ERROR', null)
      try {
        const companyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
        const result = await axios.get(`/api/company/${companyId}/notification-templates/tokens/${subjectType}/${actionType}`)
        commit('SET_TOKENS', result.data.tokenSet ? result.data.tokenSet.tokens || [] : [])
        return result.data.tokenSet ? result.data.tokenSet.tokens || [] : []
      } catch (e) {
        commit('SET_ERROR', e.response ? `${e.response.status}: ${e.response.statusText}` : e.message)
        return []
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationtemplates.js